(()=>{
const track=document.querySelector('.clip-track');
const previous=document.querySelector('.clips-prev');
const next=document.querySelector('.clips-next');
if(track&&previous&&next){
 const update=()=>{previous.disabled=track.scrollLeft<3;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
 previous.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.82,behavior:'smooth'}));
 next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.82,behavior:'smooth'}));
 track.addEventListener('scroll',update,{passive:true});
 new ResizeObserver(update).observe(track);update();
}
const videos=[...document.querySelectorAll('.clip-card video,.sleep-feature-video video')];
const visible=new Set(),pending=new WeakSet();
function play(video){
 if(document.hidden||!visible.has(video)||!video.paused||pending.has(video))return;
 video.muted=true;video.defaultMuted=true;video.playsInline=true;
 pending.add(video);
 const result=video.play();
 if(result)result.then(()=>{pending.delete(video);video.controls=false;}).catch(error=>{
  pending.delete(video);
  if(error.name==='NotAllowedError')video.controls=true;
 });else pending.delete(video);
}
videos.forEach(video=>{
 video.muted=true;video.defaultMuted=true;video.playsInline=true;
 video.setAttribute('muted','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');
 if(video.dataset.src){video.src=video.dataset.src;delete video.dataset.src;video.load();}
 ['loadeddata','canplay'].forEach(event=>video.addEventListener(event,()=>play(video)));
});
const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
 const video=entry.target;
 if(entry.isIntersecting&&entry.intersectionRatio>=.1){visible.add(video);play(video);}
 else{visible.delete(video);video.pause();}
}),{threshold:[0,.1]});
videos.forEach(video=>observer.observe(video));
const resume=()=>visible.forEach(play);
['touchend','click','keydown'].forEach(event=>document.addEventListener(event,resume,{passive:true}));
document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach(video=>video.pause());else resume();});
window.addEventListener('pageshow',resume);
})();